import { render } from "./GameItem.vue?vue&type=template&id=16d449b0&scoped=true&ts=true"
import script from "./GameItem.vue?vue&type=script&lang=ts"
export * from "./GameItem.vue?vue&type=script&lang=ts"

import "./GameItem.vue?vue&type=style&index=0&id=16d449b0&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16d449b0"]])

export default __exports__